import React, { useState, useEffect } from "react";
import FeatureCard from "./FeatureCard";
import { formatDateLong, formatGrade } from "../helper/formatters";
import { getAssignmentStats } from "../../requests";
import { notifyError } from "../helper/Toaster";
import { deleteAuthToken } from "../../utils/helper";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "../../_css/Overview.css";
import SearchableDropdown from "../common/SearchableDropdown";
import CustomChart from "../common/CustomChart";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";

const AssignmentUI = () => {

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [totalCount, setTotalCount] = useState(0);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [teacherList, setTeacherList] = useState([]);
  const [subject, setSubject] = useState("");
  const [grade, setGrade] = useState("");

  const [students, setStudents] = useState([]);
  const [stats, setStats] = useState({
    total_assignment_created: 0,
    total_submission_recieved: 0,
    top_performing_student: 0,
    avg_student_score_per_assignment: 0,
  });

  const get_students = async (pageVal) => {

    let subject_s = subject == "All subjects" ? "" : subject;
    let grade_s = grade == "All classes" ? "" : grade;
  
    dispatch(startLoader());
    try {
      const res = await getAssignmentStats({page: pageVal, limit: limit, subject: subject_s, grade: grade_s});

      setTotalCount(res.data.totalCount);
      const students_data =  res.data.data;
      setStudents(students_data);
    
      
      //set Stats
      setStats((p) => ({
        ...p,
        total_assignment_created: res.data.stats.total_assignment_created,
        total_submission_recieved: res.data.stats.total_submission_recieved,
        top_performing_student: res.data.stats.top_performing_student,
        avg_student_score_per_assignment: res.data.stats.avg_student_score_per_assignment,
      }));
    } catch (error) {
      if (error?.response?.status == 403) {
        notifyError(
          error?.response?.data?.error || "Your session has expired. Please log in again."
        );
        deleteAuthToken();
        navigate("/login");
        return;
      }

      notifyError("Error fetching students");
    } finally {
      dispatch(stopLoader());
    }
  };

  // const filterStudents = async (e) => {
  //   // const grade = e.target.name == 'grade' && e.target.value

  //   // const name = e.target.name == 'name' && e.target.value

  //   let subject_s = subject == "All subjects" ? "" : subject;
  //   let grade_s = grade == "All classes" ? "" : grade;

  //   if (!subject_s && !grade_s) {
  //     setFilteredStudents(students);
  //     get_students();
  //   }

  //   if (subject_s && grade_s) {
  //     const stu_s = students.filter(
  //       (e) =>
  //         e?.grade == grade_s &&
  //         e?.subject?.toLowerCase().startsWith(subject_s?.toLowerCase())
  //     );

  //     const total_assignment_created = stu_s.length;
  //     const total_submission_recieved = stu_s.filter(
  //       (e) => e.status == 1
  //     ).length;
  //     const top_performing_student = stu_s.sort(
  //       (a, b) => b.marks_obt - a.marks_obt
  //     )[0].student_name;
  //     const avg_student_score_per_assignment =
  //       stu_s.reduce((acc, e) => acc + Number(e.marks_obt), 0) / stu_s.length;

  //     setStats((p) => ({
  //       ...p,
  //       total_assignment_created: total_assignment_created,
  //       total_submission_recieved: total_submission_recieved,
  //       top_performing_student: top_performing_student,
  //       avg_student_score_per_assignment: avg_student_score_per_assignment,
  //     }));

  //     setFilteredStudents(stu_s);

  //     return;
  //   }

  //   if (subject_s) {
  //     const stu_s = students.filter((e) =>
  //       e?.subject.toLowerCase().startsWith(subject_s?.toLowerCase())
  //     );


  //     const total_assignment_created = stu_s.length;
  //     const total_submission_recieved = stu_s.filter(
  //       (e) => e.status == 1
  //     ).length;
  //     const top_performing_student = stu_s.sort(
  //       (a, b) => b.marks_obt - a.marks_obt
  //     )[0].student_name;
  //     const avg_student_score_per_assignment =
  //       stu_s.reduce((acc, e) => acc + Number(e.marks_obt), 0) / stu_s.length;

  //     setStats((p) => ({
  //       ...p,
  //       total_assignment_created: total_assignment_created,
  //       total_submission_recieved: total_submission_recieved,
  //       top_performing_student: top_performing_student,
  //       avg_student_score_per_assignment: avg_student_score_per_assignment,
  //     }));



  //     setFilteredStudents(stu_s);

  //     return;
  //   }

  //   if (grade_s) {
  //     const stu_s = students.filter((e) => e?.grade == grade_s);


  //     const total_assignment_created = stu_s.length;
  //     const total_submission_recieved = stu_s.filter(
  //       (e) => e.status == 1
  //     ).length;
  //     const top_performing_student = stu_s.sort(
  //       (a, b) => b.marks_obt - a.marks_obt
  //     )[0].student_name;
  //     const avg_student_score_per_assignment =
  //       stu_s.reduce((acc, e) => acc + Number(e.marks_obt), 0) / stu_s.length;

  //     setStats((p) => ({
  //       ...p,
  //       total_assignment_created: total_assignment_created,
  //       total_submission_recieved: total_submission_recieved,
  //       top_performing_student: top_performing_student,
  //       avg_student_score_per_assignment: avg_student_score_per_assignment,
  //     }));

  //     setFilteredStudents(stu_s);

  //     return;
  //   }
  // };



  useEffect(() => {
    setPage(1);
    get_students(1);
  },[subject,grade]);

  useEffect(() => {
    get_students(page);
  }, [page,limit]);

 

  const subjects = [
    "All subjects",
    "Mathematics",
    "English",
    "Science",
    "History",
    "Geography",
    "Physics",
    "Chemistry",
    "Biology",
    "Computer Science",
    "Information Technology",
    "Environmental Science",
    "Political Science",
    "Economics",
    "Business Studies",
    "Accountancy",
    "Sociology",
    "Psychology",
    "Philosophy",
    "Civics",
    "Literature",
    "Grammar",
    "Statistics",
    "Engineering Drawing (Theory)",
    "Design and Technology (Theory)",
    "Astronomy",
    "Geology",
    "Anthropology",
    "Archaeology",
    "Law",
    "Media Studies",
    "Communication Skills (Theory)",
    "Entrepreneurship",
    "Marketing",
    "Tourism and Hospitality (Theory)",
    "Fashion Studies (Theory)",
    "Agriculture (Theory)",
    "Computer Applications",
    "Applied Mathematics",
    "Modern History",
    "World History",
    "Ancient History",
    "Political Theory",
    "International Relations",
    "Public Administration",
    "Linguistics",
    "Environmental Studies",
    "Current Affairs",
    "General Knowledge",
    "Moral Science",
  ];

  const classes = ["All classes", 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  return (
    <div className="tm-main">
      <div className="overview-head">
        <div className="overview-head-left">Assignment Monitoring</div>
        <div className="overview-head-right">
          <SearchableDropdown
            options={[...subjects]}
            selected={subject}
            setSelected={(e) => setSubject(e)}
            color="#E5E7EB"
          />
          <SearchableDropdown
            options={[...classes]}
            selected={grade}
            setSelected={(e) => setGrade(e)}
            color="#E5E7EB"
            allowManualEntry={false}
          />
        </div>
      </div>
      <div className="overview-card-con di-flex">
        <FeatureCard
          title="Total Assignment Created"
          desc={stats?.total_assignment_created}
          color="#F0FAFF"
        />
        <FeatureCard
          title="Total Submission Recieved"
          desc={stats?.total_submission_recieved}
          color="#ECFDF5"
        />
        <FeatureCard
          title="Top Performing Student"
          desc={stats?.top_performing_student}
          color="#FEF2F2"
        />
        <FeatureCard
          title="Avg Student Score per Assignment"
          desc={stats?.avg_student_score_per_assignment.toFixed(2)}
          color="#FEFCE8"
        />
      </div>

      <div className="ai-fd-table">
        <div className="ai-fd-table-head">
          <div className="ai-fd-head-cell" style={{ width: "18%" }}>
            Student Name
          </div>
          <div className="ai-fd-head-cell" style={{ width: "16%" }}>
            Score
          </div>
          <div className="ai-fd-head-cell" style={{ width: "16%" }}>
            Class
          </div>
          <div className="ai-fd-head-cell" style={{ width: "16%" }}>
            Roll no
          </div>

          <div className="ai-fd-head-cell" style={{ width: "16%" }}>
            Subject
          </div>
          <div className="ai-fd-head-cell" style={{ width: "18%" }}>
            Uploaded On
          </div>
        </div>
        {students.length > 0 &&
          students.map((e, i) => (
            <div key={i} className="ai-fd-table-row">
              <div className="ai-fd-row-cell" style={{ width: "18%" }}>
                {e.student_name}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "16%" }}>
                {Number(e.marks_obt)}/{Number(e.marks_total)}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "16%" }}>
                {formatGrade(e.grade)}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "16%" }}>
                {e.student_rollno}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "16%" }}>
                {e.subject}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "18%" }}>
                {formatDateLong(e.created_at)}
              </div>
            </div>
          ))}
      </div>
      <div className="di-flex" style = {{width: '100%'}}>
          <div style={{ color: "#6B7280" }}>
            {" "}
            Showing {((page-1) * limit )+ 1} to {students.length + (page - 1) * limit} out of {totalCount}{" "}
            items{" "}
          </div>
          <div
            className="di-flex"
            style={{ justifyContent: "end", gap: "10px" }}
          >
            <button
              disabled={page == 1}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity: page == 1 ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (p > 1 ? p - 1 : p))}
            >
              Previous
            </button>
            <button
              disabled={students.length + (page - 1) * limit >= totalCount}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity:
                  students.length + (page - 1) * limit >= totalCount ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (students.length ? p + 1 : p))}
            >
              Next
            </button>
          </div>
        </div>
    </div>
  );
};

export default AssignmentUI;
